// context/SearchStockContext.jsx

import {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
  useCallback,
} from "react";

import axios from "axios";

const SearchStockContext = createContext();

// export const SearchStockProvider = ({ children }) => {
//   /* =========================================
//      SEARCH STATES
//   ========================================= */

//   const [searchStockQuery, setSearchStockQuery] = useState("");

//   const [searchResults, setSearchResults] = useState([]);

//   const [searchLoading, setSearchLoading] = useState(false);

//   const [selectedSearchStock, setSelectedSearchStock] = useState(null);

//   const searchDebounceRef = useRef(null);

//   const BASE_URL = process.env.REACT_APP_API_BASE_URL;

//   /* =========================================
//      SEARCH STOCKS
//   ========================================= */

//   const searchStocks = async (query) => {
//     try {
//       if (!query?.trim()) {
//         setSearchResults([]);

//         return;
//       }

//       setSearchLoading(true);

//       const response = await axios.get(`${BASE_URL}/api/search-db-stocks`, {
//         params: {
//           query,
//         },
//       });

//       setSearchResults(response?.data?.data || []);
//     } catch (err) {
//       console.error("Search failed:", err);
//     } finally {
//       setSearchLoading(false);
//     }
//   };

//   /* =========================================
//      DEBOUNCE SEARCH
//   ========================================= */

//   useEffect(() => {
//     clearTimeout(searchDebounceRef.current);

//     if (!searchStockQuery.trim()) {
//       setSearchResults([]);

//       return;
//     }

//     searchDebounceRef.current = setTimeout(() => {
//       searchStocks(searchStockQuery);
//     }, 300);

//     return () => clearTimeout(searchDebounceRef.current);
//   }, [searchStockQuery]);

//   /* =========================================
//      SELECT SEARCH STOCK
//   ========================================= */

//   const handleSelectSearchStock = (stock) => {
//     setSelectedSearchStock(stock);

//     setSearchStockQuery(stock.symbol);

//     setSearchResults([]);
//   };

//   /* =========================================
//      CLEAR SEARCH STOCK
//   ========================================= */

//   const clearSelectedSearchStock = () => {
//     setSelectedSearchStock(null);

//     setSearchStockQuery("");

//     setSearchResults([]);
//   };

//   return (
//     <SearchStockContext.Provider
//       value={{
//         searchStockQuery,
//         setSearchStockQuery,

//         searchResults,

//         searchLoading,

//         selectedSearchStock,
//         setSelectedSearchStock,

//         handleSelectSearchStock,

//         clearSelectedSearchStock,
//       }}
//     >
//       {children}
//     </SearchStockContext.Provider>
//   );
// };

// export const SearchStockProvider = ({ children }) => {
//   const [searchStockQuery, setSearchStockQuery] = useState("");

//   // existing
//   const [searchResults, setSearchResults] = useState([]);

//   // new
//   const [indexResults, setIndexResults] = useState([]);
//   const [equityResults, setEquityResults] = useState([]);

//   const [searchLoading, setSearchLoading] = useState(false);

//   const [selectedSearchStock, setSelectedSearchStock] = useState(null);

//   const searchDebounceRef = useRef(null);

//   const BASE_URL = process.env.REACT_APP_API_BASE_URL;

//   // const searchStocks = async (query) => {
//   //   try {
//   //     if (!query?.trim()) {
//   //       setSearchResults([]);
//   //       setIndexResults([]);
//   //       setEquityResults([]);
//   //       return;
//   //     }

//   //     setSearchLoading(true);

//   //     const response = await axios.get(`${BASE_URL}/api/search-db-stocks`, {
//   //       params: { query },
//   //     });

//   //     const all = response?.data?.data || [];
//   //     const indices = response?.data?.indices || [];
//   //     const equities = response?.data?.equities || [];

//   //     // old combined result
//   //     setSearchResults(all);

//   //     // new separated result
//   //     setIndexResults(indices);
//   //     setEquityResults(equities);
//   //   } catch (err) {
//   //     console.error("Search failed:", err);

//   //     setSearchResults([]);
//   //     setIndexResults([]);
//   //     setEquityResults([]);
//   //   } finally {
//   //     setSearchLoading(false);
//   //   }
//   // };
//   const searchStocks = async (query) => {
//     try {
//       if (!query?.trim()) {
//         setSearchResults([]);
//         setIndexResults([]);
//         setEquityResults([]);
//         return { indices: [], equities: [] }; // ✅ add return
//       }

//       setSearchLoading(true);

//       const response = await axios.get(`${BASE_URL}/api/search-db-stocks`, {
//         params: { query },
//       });

//       const indices = response?.data?.indices || [];
//       const equities = response?.data?.equities || [];

//       setSearchResults(response?.data?.data || []);
//       setIndexResults(indices);
//       setEquityResults(equities);

//       return { indices, equities }; // ✅ add return
//     } catch (err) {
//       console.error("Search failed:", err);
//       setSearchResults([]);
//       setIndexResults([]);
//       setEquityResults([]);
//       return { indices: [], equities: [] }; // ✅ add return
//     } finally {
//       setSearchLoading(false);
//     }
//   };

//   useEffect(() => {
//     clearTimeout(searchDebounceRef.current);

//     if (!searchStockQuery.trim()) {
//       setSearchResults([]);
//       setIndexResults([]);
//       setEquityResults([]);
//       return;
//     }

//     searchDebounceRef.current = setTimeout(() => {
//       searchStocks(searchStockQuery);
//     }, 300);

//     return () => clearTimeout(searchDebounceRef.current);
//   }, [searchStockQuery]);

//   const handleSelectSearchStock = (stock) => {
//     setSelectedSearchStock(stock);

//     setSearchStockQuery(
//       stock.displayName || stock.underlyingSymbol || stock.symbol,
//     );

//     setSearchResults([]);
//     setIndexResults([]);
//     setEquityResults([]);
//   };

//   const clearSelectedSearchStock = () => {
//     setSelectedSearchStock(null);
//     setSearchStockQuery("");
//     setSearchResults([]);
//     setIndexResults([]);
//     setEquityResults([]);
//   };

//   return (
//     <SearchStockContext.Provider
//       value={{
//         searchStockQuery,
//         setSearchStockQuery,

//         searchResults,
//         indexResults,
//         equityResults,

//         searchLoading,
//         searchStocks,

//         selectedSearchStock,
//         setSelectedSearchStock,

//         handleSelectSearchStock,
//         clearSelectedSearchStock,
//       }}
//     >
//       {children}
//     </SearchStockContext.Provider>
//   );
// };

//new code some changes

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const SearchStockProvider = ({ children }) => {
  const [searchStockQuery, setQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [indexResults, setIndexResults] = useState([]);
  const [equityResults, setEquityResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [selectedSearchStock, setSelectedSearchStock] = useState(null);

  const searchDebounceRef = useRef(null);
  const controllerRef = useRef(null);
  const requestIdRef = useRef(0);

  const cancelPendingSearch = useCallback(() => {
    ++requestIdRef.current;
    clearTimeout(searchDebounceRef.current);
    controllerRef.current?.abort();
    controllerRef.current = null;
  }, []);

  const resetResults = useCallback(() => {
    setSearchResults([]);
    setIndexResults([]);
    setEquityResults([]);
    setSearchLoading(false);
  }, []);

  // Keep the same public setter name used by Navbar.
  const setSearchStockQuery = useCallback(
    (value) => {
      cancelPendingSearch();
      resetResults();
      setQuery(value);
    },
    [cancelPendingSearch, resetResults],
  );

  const searchStocks = useCallback(
    async (query) => {
      cancelPendingSearch();
      resetResults();

      const trimmedQuery = query?.trim() || "";
      const emptyResults = { indices: [], equities: [] };

      if (!trimmedQuery) return emptyResults;

      const requestId = requestIdRef.current;
      const controller = new AbortController();
      controllerRef.current = controller;

      const isCurrent = () =>
        requestId === requestIdRef.current && !controller.signal.aborted;

      try {
        setSearchLoading(true);

        const response = await axios.get(`${BASE_URL}/api/search-db-stocks`, {
          params: { query: trimmedQuery },
          signal: controller.signal,
        });

        if (!isCurrent()) return emptyResults;

        const indices = response?.data?.indices || [];
        const equities = response?.data?.equities || [];

        setSearchResults(response?.data?.data || []);
        setIndexResults(indices);
        setEquityResults(equities);

        return { indices, equities };
      } catch (err) {
        if (!isCurrent()) return emptyResults;

        console.error("Search failed:", err);
        resetResults();

        return emptyResults;
      } finally {
        if (isCurrent()) {
          setSearchLoading(false);
          controllerRef.current = null;
        }
      }
    },
    [cancelPendingSearch, resetResults],
  );

  useEffect(() => {
    if (searchStockQuery.trim()) {
      searchDebounceRef.current = setTimeout(() => {
        searchStocks(searchStockQuery);
      }, 300);
    }

    return cancelPendingSearch;
  }, [searchStockQuery, searchStocks, cancelPendingSearch]);

  const handleSelectSearchStock = useCallback(
    (stock) => {
      setSelectedSearchStock(stock);
      setSearchStockQuery("");
    },
    [setSearchStockQuery],
  );

  const clearSelectedSearchStock = useCallback(() => {
    setSelectedSearchStock(null);
    setSearchStockQuery("");
  }, [setSearchStockQuery]);

  return (
    <SearchStockContext.Provider
      value={{
        searchStockQuery,
        setSearchStockQuery,
        searchResults,
        indexResults,
        equityResults,
        searchLoading,
        searchStocks,
        selectedSearchStock,
        setSelectedSearchStock,
        handleSelectSearchStock,
        clearSelectedSearchStock,
      }}
    >
      {children}
    </SearchStockContext.Provider>
  );
};

export const useSearchStock = () => {
  return useContext(SearchStockContext);
};
